const delay = (ms = 220) => new Promise((r) => setTimeout(r, ms));

const iso = (days) => new Date(Date.now() + days * 864e5).toISOString();

// A gift from an earlier purchase, so the "where did this come from" case is
// exercisable offline.
let _cards = [
  { id: 'card-gift', typeCode: 'gift_3m',
    name: { fa: 'کارت هدیه سه‌ماهه', en: '3-month Gift Card' },
    status: 'active', retentionDays: 92, pricePaid: 0,
    activatedAt: iso(-10), expiresAt: iso(82), note: 'consultation' },
];

const _types = [
  { code: 'care_6m', name: { fa: 'کارت مراقبت ۶ ماهه', en: '6-month Care Card' },
    description: { fa: 'تصاویر شما تا شش ماه نگهداری می‌شود.', en: 'Photos kept for six months.' },
    retentionDays: 182, priceToman: 4900000, features: [] },
  { code: 'care_12m', name: { fa: 'کارت مراقبت ۱۲ ماهه', en: '12-month Care Card' },
    description: { fa: 'تصاویر شما تا یک سال نگهداری می‌شود.', en: 'Photos kept for a year.' },
    retentionDays: 365, priceToman: 8900000, features: [] },
];

export async function listTypes() { await delay(); return { types: _types }; }

export async function myCards() {
  await delay();
  const active = _cards.filter((c) => c.status === 'active' && c.expiresAt);
  const photosKeptUntil = active.length
    ? active.map((c) => c.expiresAt).sort().slice(-1)[0] : null;
  return { cards: _cards, photosKeptUntil };
}

export async function buy(typeCode, gateway, discountCode) {
  void discountCode; // priced server-side in real mode
  await delay(380);
  if (gateway) return { paymentUrl: `https://example.invalid/${gateway}/pay`, gateway };
  const ty = _types.find((t) => t.code === typeCode);
  _cards = [{ id: `card-${Date.now()}`, typeCode, name: ty.name, status: 'active',
    retentionDays: ty.retentionDays, pricePaid: ty.priceToman,
    activatedAt: new Date().toISOString(), expiresAt: iso(ty.retentionDays) }, ..._cards];
  return { bypassed: true, card: _cards[0] };
}

export const cardsApi = { listTypes, myCards, buy };
export default cardsApi;
